import { APP_INITIALIZER } from '@angular/core';
import { ModuleStore } from '@core';
import { APP_ROUTES_CONFIG, AppRouteConfig } from '@contracts';

export function initModule(
  moduleStore: ModuleStore,
  config: AppRouteConfig,
) {
  return () => {
    const saved = localStorage.getItem('module');

    const validModules = Object.keys(config.moduleRoutes);

    if (!saved || !validModules.includes(saved)) {
      const def = config.defaultModule ?? validModules[0];

      if (!def) {
        throw new Error('No module available in config');
      }

      moduleStore.setModule(def);
    }
  };
}

export const moduleInitializer = {
  provide: APP_INITIALIZER,
  useFactory: initModule,
  deps: [ModuleStore, APP_ROUTES_CONFIG],
  multi: true,
};